import { IDataTh, ThCoreIndex } from "src/Pages/components";

export const THeadModalidade = () => {
  const dataTh: IDataTh[] = [
    {
      title: "Ações",
      width: "40px",
      align: "left",
    },
    {
      tooltip: "Código - Modalidades",
      title: "Cod - Modalidades",
      align: "left",
      width: "90%",
    },
    {
      title: "Ativo",
      align: "center",
      width: "100px",
    },
  ];

  return <ThCoreIndex dataTh={dataTh} />;
};
